import { UserSettings } from 'services/db/Queries/UserSettingsQueries'
import LocalStorage from 'services/LocalStorage'
import { EventDoc } from 'types/api/changes'
import { ICalendar } from 'types/google_events'
import { LocalStorageKey } from 'types/services/localStorage'

import { icloudPrefix, outlookPrefix } from './constants'
import { CurrentConvertedCalendars } from './google_events'

export function thirdPartyCalendarIdToPrimaryEmail(id: string): string {
  return (
    CurrentConvertedCalendars.find((calendar) => calendar.id === id)
      ?.primaryCalendarEmail || ''
  )
}

export function isIcloudEvent(event: EventDoc) {
  return (
    CurrentConvertedCalendars.find(
      (calendar) => calendar.localId === event.GroupID
    )?.prefix === icloudPrefix
  )
}

export function isOutlookEvent(event: EventDoc) {
  return (
    CurrentConvertedCalendars.find(
      (calendar) => calendar.localId === event.GroupID
    )?.prefix === outlookPrefix
  )
}

export function cacheConvertedCalendarsToLocalStorage() {
  if (CurrentConvertedCalendars.length === 0) {
    LocalStorage.remove(LocalStorageKey.CACHED_CONVERTED_CALENDARS)
    return
  }

  const cached = LocalStorage.get(LocalStorageKey.CACHED_CONVERTED_CALENDARS)
  const cachedCalendars: ICalendar[] = cached ? JSON.parse(cached) : []

  // if there are already cached calendars, we want to keep the syncable property of them (if exist)
  const calendarsToCache = CurrentConvertedCalendars.map((calendar) => {
    const cachedCalendar = cachedCalendars.find((c) => c.id === calendar.id)
    return {
      ...calendar,
      syncable: cachedCalendar ? cachedCalendar.syncable : true
    }
  })

  UserSettings()
    .then((us) => {
      if (us) {
        const groupsSettings = us.GroupsSettings || {}

        for (const calendar of calendarsToCache) {
          const groupSetting = groupsSettings[calendar.localId ?? '']

          if (groupSetting) {
            calendar.syncable =
              groupSetting.ConvertedCalendars?.find(
                (cal) => cal.id === calendar.id
              )?.syncable ?? calendar.syncable
          }
        }
      }
    })
    .finally(() => {
      LocalStorage.set(
        LocalStorageKey.CACHED_CONVERTED_CALENDARS,
        JSON.stringify(calendarsToCache)
      )
    })
}

export function getCachedConvertedCalendarsFromLocalStorage(): ICalendar[] {
  const cached = LocalStorage.get(LocalStorageKey.CACHED_CONVERTED_CALENDARS)
  const inMemory = CurrentConvertedCalendars

  return cached ? JSON.parse(cached) : inMemory
}
